import { StatusScreenType } from "./types";

export const StatusScreenThemeMap: Record<
  StatusScreenType,
  { backgroundColor: string; icon: string; fontColor: string }
> = {
  [StatusScreenType.success]: {
    backgroundColor: "$primary0",
    fontColor: "$primary600",
    icon: "check-circle",
  },
  [StatusScreenType.info]: {
    backgroundColor: "$backgroundLightInfo",
    fontColor: "$info600",
    icon: "verified",
  },
  [StatusScreenType.error]: {
    backgroundColor: "$error00",
    fontColor: "$error600",
    icon: "times-circle",
  },
};
